import { render, staticRenderFns } from "./PendingLinkedRequests.vue?vue&type=template&id=6f3ea072&scoped=true&"
import script from "./PendingLinkedRequests.vue?vue&type=script&lang=js&"
export * from "./PendingLinkedRequests.vue?vue&type=script&lang=js&"
import style0 from "./PendingLinkedRequests.vue?vue&type=style&index=0&id=6f3ea072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ea072",
  null
  
)

export default component.exports